export default {



	breadcrumbBefore: ['首頁', '會員中心'], // 集運權限  和  官網展示


	locale: '繁體中文', // 語言切換
	exit: '安全退出', //註銷按鈕
	hi: 'Hi,', // 顯示昵稱問候語
	loginOperations: ['會員登入', '會員登記', '忘記密碼'], //未登錄時的三個狀態文字
	signIn: ['登入', '集運'],

	navtop: [ // 頂部導航欄
		'網站首頁',

		// '多寶放提',
		// '多寶狂淘',
		'綠色集運',
		'常見問題',
		'集運須知',
		'倉庫及報價',
		'自取點',
	],

	footer: { //底部描述
		first: '公司簡介',
		second: '使用條款及免責聲明',
		third: '隱私權保護聲明',
		fourth: '集運條款及細則',
		fifth: '多寶網©$ 版權所有',
	},

	aside: { //側邊導航欄   children  子導航欄key
		first: {
			name: '多寶集運',
			children: ['貨品認領', '我的訂單']
		},
		second: {
			name: '多寶狂淘',
			children: ['我要分享', '我的分享', '淘友留言']
		},
		third: {
			name: '會員中心',
			children: ['賬戶', '集運地址', '地址簿', '積分', '安全退出','優惠券']
		},
	},

	asideDescription: [{
		tips: {
			phone: '電話必須為8到11位數字',
			content: '描述不少於2個字元',
			category: '類別必填'
		},
		title: '商務合作',
		p: '多寶集運全港設有數十個自取點及流動自取站，歡迎網店或零售商合作派送及自取業務。',
		form: [{
			placeholder: '請選擇類型',
			label: '類型',
			options: ['商務合作', '優惠提供', '業務投訴']
		}, {
			label: '電話',
			placeholder: '填入電話號碼'
		}, {
			label: '描述',
			placeholder: '填寫描述內容 。'
		},
		['提交', '重置']
		]
	},
	{
		title: '聯絡我們',
		p: ` <article class="strong">客服在線時間(紅日休息)</article>
        <div class="flex justify-between">
          <span>星期一至六</span>
          <span>09:30 - 12:30</span> 
        </div>
        <div class="text-right">13:30 - 18:30</div>
        <br />
        <article class="text-bold u-m-b-4">地址</article>土瓜灣郵政局 郵箱 87064號`
	},
	{
		title: 'Facebook專頁',
		p: []
	}
	],

	recommend: ['好物推薦', '價錢', '加載中'], // 好物推薦這項 因為後加

	//  基礎佈局完畢

	//抽離公用的組件
	commons: {
		OrderComment: ['評價訂單', '請給我們意見，讓我們改進服務。', '派送服務', '物流時效', '客服質素', '發送中', '發送','相片(如有)','請給派送服務評星','請給物流時效評星','請給客服質素評星'], // 組件  OrderComment
		MoreInfo: {
			last: '沒有更多了',
			loading: '小寶正在努力加載中...',
			more: '點我加載更多',
			noneMessage: '小寶查過了，沒有更多了',
		},
		FormButtons: {
			send: '送出',
			reset: '重置'
		},
		unit: { //單位  公用
			ge: '個',
			jian: '件',
			gong: '共'
		},
		input_placeholder: '請輸入',
		select_placeholder: '請選擇',
		no_more: '无数据',
		successfully: '操作成功',
		unsuccessfully: '操作失敗'
	},


	//   我的貨品  ------- ------------------------------------
	jiyun: {
		breadcrumb: '貨品認領',
		expand: ['該貨品有以下子運單號', '一鍵認領'], // 展開的一鍵盤認領

		form: {
			tips: '請輸物流公司及運單號碼認領貨件，貨到大陸倉，我們會於辦公時間8小時內更新貨件資料。',

			eid: { label: '倉庫及物流' },
			enum: { label: '物流單號' },
			repack: {
				label: '去箱服務',
				desc: '（需要收服務費）'
			},
			items: {
				label: '申報名稱',
				tables: {
					title: '請如實申報貨品詳情',
					add: '添加',
					props: {
						name: {
							label: '貨品名稱',
						},
						category: {
							label: '貨品類別',
						},
						qty: {
							label: '數量',
						},
						unit: {
							label: '單價',
						},
						opera: {
							label: '操作',
							delete: '刪除'
						}
					}
				}
			},
			buttons: ['送出', '重置']
		},
		rules: {
			eid: '請選擇賣家發貨物流公司',
			enum: '請輸入正確的運單號碼',
			items: '申报信息不完整'
		},

		form2: {
			label: '你知道嗎？即使貨品未到倉，都可以預先選取貨品安排集運，當貨品到齊後，我們就會自動給你發貨 ( 僅限自取 )。',
			// 第4個按鈕 為右上角  alert屬性   按鈕的警告彈窗提示
			buttons: ['全部貨品', '未入倉', '已入倉', {
				name: '集運給我',
				alert: '請選擇需要集運的商品'
			}]
		}, //表格項名稱列表
		table: ['物流公司', '運單號碼', {
			column: '重量',
			title: ['實重', '尺寸']
		}, '倉庫', '操作'],
		operatingGroups: { //operating 項的操作按鈕
			search: {
				pop: '追蹤物流資訊'
			},
			re_declare: {
				pop: '重新申報'
			},
			delete: {
				pop: '刪除貨品',
				modal: {
					title: '小寶說',
					left: '確定要刪除貨品',
					right: ' 嗎?',
					confirm: '確定',
					cancel: '取消',
				}
			}
		}, //footer 部分
		import: {
			key: '入倉日期',
			default: '未入倉'
		},
		custom: {
			key: '海關申報'
		},
		comment: {
			key: '我的備註',
			placeholder: '備註內容僅自已可見',
			noShelfTips: '此貨品經己簽收，但由於貨量激增，此貨品未能安排入庫，請耐心等侯，我們會盡快處理。如己入庫之貨品請盡快集運，以便我們騰出更多倉位，謝謝。'
		},



		request: { // show_ship_limit_notice 方法中 confirm提示
			title: '國內禁運品更新通知',
			content: '中國海關通知，即日起國內集運將以下物品列為禁運品，請大家留意。<br/>所有經由我司轉運的貨品，均會百分百經過X光機檢查，請所有客戶如實申報。<br/>如發現禁運品或虛報資料，一律會以退件或標示為 禁運 處理，有關安排將不會作出通知及任何賠償。<br/>請留意 禁運品 是由 海關定義，貨物種類或會有增減，<br/>因此 包括但不限於以下產品:<br/>刀劍、彈弓、弓箭、雨傘、旗幟、旗桿、宣傳橫額、無人機、棍棒、黑色T恤、純色T恤、金屬管、螢光棒、雷射筆、面具、頭盔、手套、口罩、眼罩、鋼珠、手電筒 等等。<br/>如對購買貨物有疑問，請先向客服查詢，不便之處，敬請見諒。',
			confirm: {
				confirm: '不再提醒',
				cancel: '取消',
			}
		},
	},

	payment: {
		breadcrumb: '支付訂單',
		descs: {
			order: '訂單',
			type: '集運方式',
			weight: '重量',
			amount: '金額',
			receiver: '收件人',
			phone: '電話',
			address: '地址'
		},
		section_title: "我們支持以下支付方式",
		waiting_for_code: '稍等片刻，正在生成支付碼',
		click_to: '按此跳轉到 $1 支付',
		paied_text: '按此完成支付'
	},

	// 貨品認領  第二步驟
	step2: {
		breadcrumb: '選擇集運方式',


		uncheck: '請選擇一個集運方式',

		notify: {
			title: '溫馨提示',
			message: '小寶已幫你選中上一次使用的集運方式，如無更改可直接進入下一步'
		},
		type_list: [{
			id: '',
			title: '所有類型'
		},
		{
			id: 1,
			title: "自取點"
		},
		{
			id: 2,
			title: "自取車"
		},
		{
		    id: 3,
		    title: "自提櫃"
		},
		{
			id: 4,
			title: "派送"
		},
		{
			id: 5,
			title: "國內轉寄"
		},
			// {
			// 	id: 6,
			// 	title: "國際轉運"
			// }
		],
		buttons: ['貨品數量', '未入倉', '計費重量'],
		nextButton: '下一步',

		card: ['首', '續每'], //卡片

		tips: {
			warn: '皆因你所選取的貨品中，有部分尚未到倉，所以只能選擇送往自取點。訂單金額以貨品到齊後審核為準。',
			info: '當前篩選條件下無可用選項'
		},
		loading: "檢索中",



		search: {
			placeholder: '請輸入地址關鍵字,如 土瓜灣',
			label: '搜尋',
			tip: '找不到想要的選項？試試輸入關鍵字搜尋。',
			settle_weight: '結算重量'
		},
		auto_forward_tips: '自取車訂單限長1.5米、限重10Kg。自動集運訂單注意不要超過限制，否則將有機會不能正常付運。',
		locker_tips:'自提櫃集運每單上限3公斤 ; 尺寸不超過 35x30x45 CM',
		alternative_mode_tips: [
			'請選擇備選取貨點',
			'如果貨品操作後未能滿足自提櫃投遞要求,我們會將你的貨品投遞到備選取貨點',
			'重新選擇'
		],
		cate_all: '所有區域',

		no_keyword: '请输入关键字',

		no_applicable: '不適用',


	},
	// 第三步頁面
	step3: {
		breadcrumb: '確認訂單',

		pageHeaders: [{
			title: '收貨資訊',
			subTitle: '變更收件人資訊',
			list: ['收件', '地址', '郵編', '按此補齊區號'],
			default: '暫無可用收件地址，按此添加'
		},
		// if ul keys     else table keys
		{
			title: '貨品清單',
			if: {
				left: ['運單', '重量'],
				right: [{
					label: '品名',
					placeholder: '英文品名'
				},
				{
					label: '材質',
					placeholder: '英文材質'
				},
				{
					label: '貨值',
					placeholder: '內件價值'
				},
				{
					label: '數量',
					placeholder: '內件數量'
				}
				]
			},
			else: {
				labels: ['快遞公司', '運單號', '實重', '泡重', '貨品資料'],
				widthHover: '尺寸'
			}
		},


		{
			title: '訂單詳情',
			items: ['訂單號', '集運方式', '件數', '計費重量','備選']
		},


		{
			title: '訂單結算',
			key: '使用積分',
			unit: '個',
			labels: ['基礎運費', '積份抵扣', '實付金額', '送出訂單', '逾期費', '支付方式'],
			warn: '當前訂單送出後將生成自動集運集運訂單，貨品全部到倉後由系統自動審核發出，訂單重量及運費以系統審核為準。',
			paymentLabel: {
				cash: '貨到付款',
				online: '網上支付'
			}
		},


		{
			title: '注意事項',
			timelines: ['嚴禁承運違禁品包括冒牌貨品及任何侵權物品等，違者一律送官究治，有關戶亦會被即時終止。',
				'必需如實申報快遞方式及繳付運費，否則不會發貨，本公司有權追討少付之運費及行政費$500元。',
				'本公司對於物品運送的延誤或遺失所造成的間接損失或其他非主體性損失不承擔任何賠償責任。',
				'積分兌換現金每次最少使用50分，最多可用200分。多寶網對積分之使用及可兌換金額保留最終裁決權。'
			]
		}
		],
		tips: { // javascript 中的提示文字     key 對應的方法
			handleChange: '使用積分兌換金額不能高於本次集運應付金額',
			score_placeholder: {
				before: '共',
				after: '個',
				after2: '個，當前不可使用'
			},
		},
		scoreLabel: '積分',
		contactDialog: {
			title: '提示',
			content: '收件電話缺少區號是否補齊？'
		}
	},
	// order  頁面
	odrder: {
		// 頂部按鈕
		breadcrumb: '我的訂單',

		buttons: ['全部訂單', '待完成', '待發貨', '可取貨'],
		card: {
			unit: '件',
			status: ['已取貨', '可取貨', '待發貨', '已發貨','到達香港'],
			steps: ['訂單已經創建，請按下一步繼續', '訂單尚未完成，請確認訂單後方可發貨',
				'訂單尚未付款，請確付款後方可發貨', '當前訂單貨品存在模糊申報，請如實重新申報，以免海關查扣',
				'共'
			],
			buttons: ['下一步', '確認', '支付運費', '重新申報', '取消',
				'追蹤', '評價', '貨品', '訂單', '已支付待確認'
			],
			tables: ['時間', '地點和跟蹤進度'],
			completed: '待完成',

		},
		tips: { //javascript

			delete: {
				title: '小寶說',
				left: '確定要刪除訂單 #',
				right: ' 嗎?',
				confirm: '確定',
				cancel: '取消',
			},
			track: ['貨品己離開 [國內物流中心]，正送往 [香港物流中心]',
				'貨品己到達 [香港物流中心]，我們會盡快安排派送，派送查詢可在多寶官網站 LiveChat',
				'派送員正為你進行派送。派送查詢可在多寶官網站 LiveChat',
				'你的貨品己成功送達。多謝你使用我們的服務',
				'你的綱品未能成功派送，派送司機會再約時間'
			],
			trackTitle: '追蹤訂單 #'

		}
	},
	// detail 頁
	detail: {

		breadcrumb: '訂單詳情頁', //新增評價
		myComment: ['我的評價', '派送服務', '物流時效', '客服質素', '按此評價訂單'], // detail裏面加的

		pageHeaders: [{
			title: '收貨資訊',
			labels: ['收件', '地址', '郵編']
		}, {
			title: '訂單詳情',
			column: ['訂單號', '集運方式', '取貨密碼', '件數', '計費重量',
				'交易編號', '使用積分', '實付金額', '送出日期', '發貨日期', '物流單號'
			],
		}, {
			title: '貨品清單',
			column: ['快遞公司', '運單號', '實重', '泡重', '貨品資料']
		}],
		buttons: ['下一步', '確認訂單', '支付運費',
			'取消', '打印', '已支付待確認'
		],
		hover: '尺寸',
		invoice:['多寶網','新界葵青葵涌永基路55號嘉里貨運中心16樓','收據號','正式收據']
	},

	//  userDetail ExchangeCode  2連
	memberCenter: { //  
		userDetail: {
			breadcrumb: '個人資料',

			pageHeaders: [{
				title: '集運地址',
				labels: ['收件人', '收件電話', '郵政編碼', '收件地址']
			},
			{
				title: '我的帳戶',
				subTitle: '修改個人資料',
				labels: [
					'帳戶', '淘寶帳戶', '昵稱', '電話', '可用積分',"專屬用戶碼"
				]
			},
			],
			dialog: {
				title: '修改個人資料',
				formItems: [
					'昵稱', '淘寶帳戶', '電話', '舊密碼', '新密碼', '確認新密碼'
				],
				send: '送出'
			},

		},
		exchangeCode: {
			breadcrumb: '積分兌換',

			headerBox: ['每個積分兌換碼只可使用一次。', '最終解釋權歸多寶網所有。'],
			curPoints: '當前積分',
			secondItem: {
				label: '兌換碼',
				placeholder: '請輸入8位兌換碼'
			},
			scoreListTitle: '積分明細',
			scoreListTips: '＊ 僅顯示2020年10月28日之後的數據',
			table: {
				name: '項目描述',
				points: '積分',
				date: '日期'
			}
		}
	},


	//  login 頁面


	login: {
		breadcrumb: '會員登入',

		left: {
			title: '會員登入',
			items: [{
				label: '電郵',
				placeholder: '登入帳號'
			},
			{
				label: '密碼',
				placeholder: '登入密碼'
			}
			],
			button: '登入',
			validateUsername: '用戶名不能小於5位',
			validatePassword: '密碼不能小於5位'
		},
		right: {
			title: '還未成為會員',
			items: ['只要填寫簡單資料', '即可註冊成為會員使用服務'],
			button: '成為會員'
		}
	},
	404: {
		list: ['版權所有', '多寶集運', '請檢查您輸入的網址是否正確或者返回首頁', '返回首頁'],
		message: '小寶說這個頁面你不能進......'
	},
	declare: {
		breadcrumb: '重新申報貨品資料',
		title: '重新申報',
		headerBox: '應海關要求，貨品名稱需如實申報，否則可能會被查扣。',
		button: '送出',
		valid_tip: '申報數據不全'
	},
	declare_oversea: {
		// 上面一样就取 declare 的

		title: '請如實申報貨品詳情',
		add: '添加',
		tables: {
			name: '货品名称',
			category: '货品类型',
			qty: '數量',
			unit: '單價',
			oper: '操作',
			del: '删除'
		},
		submit: '重新申報'

	},

	// 組件  components.jiyun.AddAddress[0].title
	components: {
		order: {
			// 地址管理
			manage: {
				tip: '請選擇收貨倉及輸入貨品重量，即可計算集運收費。',
				keyword: '请输入搜索关键字',
				add: '新增地址',
				back: '返回訂單',
				delTips: '確定要刪除當前地址？'
			},
			template_address: {
				title: '請填寫退件地址',
				gap_tips: [
					'请正确填写国内退件地址及電話',
					'此為臨時地址，小寶不會存儲到地址簿'
				]
			},
			address_manage: {
				section: '地址薄',
				gap_tips: [
					'請填寫正確的收貨地址',
					'如果是新增電話，小寶會要求SMS驗證，以確保可以正確派送'
				],
			},

			phone_manage: {
				section: '電話薄',
				gap_tips: [
					'如果是新增電話，小寶會要求SMS驗證，以確保能收到取貨碼',
				]
			},
			// 地址form
			form: {
				title: '收件人',

				name: '收件人名稱',
				phone: '手提電話',
				verify_code: '驗證碼',
				addressPrefix: '地區',
				address: '詳細地址',
				is_default: '設為默認',

				button: '確定'
			},
			// 地址的table
			table: {
				disable_tips: '該地址不支持派送',
				def: '是否默認',
				phone: '名稱/電話',
				address: '地址',
				operate: '操作',
				del: '刪除',
				update: '修改'
			}

		},
		public: {
			manyboVerifyCode: {
				sendMsg: '發送驗證碼',
				sendingMsg: '發送中',
				sentMsg: '倒計時'
			}
		}
	},


	//  自己寫的

	home: {

		news: '最新消息',
		contact_us: '聯絡我們',
		online_cs: '線上客服',
		business_hours: '自取點營業時間',
		facebook: 'FACEBOOK 粉絲專頁',
		partner:"合作夥伴",

	},

	warehouse: {
		breadcrumb: '倉庫及報價',
	},

	hk: {
		breadcrumb: '運费估算',
		title: '集運計算機',
		tips: [
			'請選擇收貨倉及輸入貨品重量，即可計算集運收費。',
			'體積重用於計算低密度的包裹，計出來的重量，會與實重比較，取較重者計算運費。',
			'以下報價以最平的運輸方法計算，價錢謹作參考'
		],
		form: {
			warehouse: {
				label: '收貨倉',
				placeholder: '請選擇收貨倉'
			},
			weight: {
				label: '重量',
				placeholder: '請輸入重量'
			},
			repack: {
				label: '需去箱包裹數',
				placeholder: '請輸入需要拆包的數量'
			},
			volume: {
				label: '體積',
				length: '請輸入長度',
				wide: '請輸入寬度',
				height: '請輸入高度',
			},

			button: '立即估算'
		},
		search: {
			placeholder: '請輸入地址關鍵字,如 土瓜灣',
			label: '搜尋',
			tip: '找不到想要的選項？試試輸入關鍵字搜尋。',
			settle_weight: '結算重量'
		},
		empty: '搜不到內容~',
		no_keyword: '请输入关键字',
		rules: {
			wh_id: '請選擇收貨倉',
			volume: '請補全尺寸',
			weight: '請輸入重量',
		},



	},



	faq: {
		breadcrumb: '常見問題'
	},
	contact: {
		breadcrumb: '自取點',
		search: {
			placeholder: '請輸入地址關鍵字,如 土瓜灣',
			label: '搜尋',
			tip: '找不到想要的選項？試試輸入關鍵字搜尋。',
			settle_weight: '结算重量'
		},
		no_keyword: '请输入关键字',
		no_more: '沒有更多數據了',
		type_list: [{
			id: '',
			title: '所有類型'
		},
		{
			id: 1,
			title: "自取點"
		},
		{
			id: 2,
			title: "自取車"
		},
		{
		    id: 3,
		    title: "自提櫃"
		}]
		
	},

	activation: {
		breadcrumb: '帳號啟動',
		tips: [
			'點擊此處', '重新發送一封啟動郵件',
			'郵件發送提醒', '郵件已成功發送到你的郵箱，請及時進行帳號啟動。'
		]
	},
	forget: {
		breadcrumb: '忘記密碼',
		form: [{
			placeholder: '請輸入你登記時的電郵',
			label: '電郵',
			btn: '驗證碼',
			pop: '請輸入正確的郵箱格式',
			tip: '請輸入你登記時的電郵(5分鐘有效)'
		}, {
			placeholder: '請填入驗證碼',
			label: '驗證碼',
			pop: '請輸入有效驗證碼（6位）',
			tip: '請輸入有效驗證碼'
		}, {
			placeholder: '請填寫登入密碼',
			label: '重置密碼',
			pop: '密碼為6-16個字元',
			tip: '請設定你的新密碼'
		}, {
			placeholder: '請填寫確認密碼',
			label: '確認密碼',
			pop: '請和上面密碼保持一致',
			tip: '請再輸一次密碼'
		}],
		buttons: ['發送', '重置']
	},
	register: {
		breadcrumb: '會員登記',
		dialog: ['承運契約條款', '同意', '不同意'],
		finish: ['歡迎登記成為多寶會員。',
			'登入電郵啟動帳戶，即可享受多寶集運的優質服務。',
			'按此直接到登入',
			'秒後自動跳轉到登入頁'
		],
		form: [{
			placeholder: '請填寫電子郵件',
			label: '電郵',
			pop: '請輸入正確的郵箱格式',
			tip: '電郵將作為登陸帳戶，請正確填寫'
		}, {
			placeholder: '請填寫淘寶昵稱',
			label: '淘寶昵稱',
			pop: '淘寶昵稱(3-30)個字元',
			tip: '請輸入淘寶昵稱(非電郵)'
		}, {
			placeholder: '請填入你的電話',
			prefix: {
				options: [
					"中國大陸",
					"香港",
					"澳門",
					"馬來西亞",
					"美國",
					"新加坡",
					"印尼",
					"泰國",
					"菲律賓",
					"日本",
					"新西蘭",
					"澳洲",
					"加拿大"
				],
				placeholder: '地區',
				pop: '請選擇區號'
			},
			pop: '填寫常用號碼(8-11)個字元',
			tip: '選擇區號和請填寫常用號碼'
		}, {
			placeholder: '請填寫昵稱',
			label: '昵稱',
			pop: '昵稱4-20個字元',
			tip: '請填寫你的暱稱'
		}, {
			placeholder: '請填寫登入密碼',
			label: '登入密碼',
			pop: '密碼為6-16個字元',
			tip: '請設置你的密碼'
		}, {
			placeholder: '請填寫確認密碼',
			label: '確認密碼',
			pop: '請和上面密碼保持一致',
			tip: '請再輸一次密碼'
		}, {
			title: '積分兌換（可選項）',
			tip: '此處可以輸入積分兌換碼，註冊成功後即可獲贈對應積分',
			label: '兌換碼',
			placeholder: '請輸入積分兌換碼'
		}, {
			checkBox: ['我已閱讀並同意', '承運契約條款'],
			buttons: ['發送', '重置']
		}]
	},


	article: {
		_id: {
			publishTime: '發佈時間'
		},

		process: {
			breadcrumb: '集運流程',
			steps: [{
				title: '1.網購',
				step: [
					'你可在不同的網站購物，用我們國內的地址作為收貨地址.',
					'地址 : 廣東省 東莞市 常平鎮 袁山貝小龍路8號 多寶網',
					'收件人: 你的姓名',
					'電話 : 18680488481',
					'郵編 : 523583'
				]
			},
			{
				title: '2.貨品認領',
				step: '輸入賣家發貨的快遞公司及單號去認領貨品.'
			},
			{
				title: '3.集運香港',
				step: '貨品到齊後，選取你要集運的貨品，跟據指示選擇集運方式、輸入地址、電話等資料，付款後(或貨到付款)就會馬上發貨去香港'
			}
			]
		}
	},
	indication: {
		jiyun: {
			first: '按此進入集運系統',
			formIntro: [
				"按此選擇賣家發貨的物流公司（ 無則選其他 ）",
				"這裏輸入賣家發貨的物流單號",
				"這裏具體準確的輸入貨品名稱，我們將會用於海關申報",
				"然後按這裏送出就認領完成了",
				"之後選取需要集運的貨品，按這裏就可以下單了"
			],
			navIntro: [
				"認領貨品及貨品清單由此進入",
				"這裏可以查看三個月內的所有訂單資訊",
				"這裏可以把自已買的寶貝分享給淘友，並且經多寶審核可獲積分獎勵（ 積分可用於抵扣運費 ）",
				"這裏可以看到我分享的全部寶貝",
				"這裏可以回復淘友的留言",
				"這裏可以查看集運地址及修改帳戶資料",
				"這裏可以看到帳戶的可用積分，也可以兌換獲得的積分兌換碼",
				"如果你使用的不是私人電腦，用完之後記得按此退出系統"
			]
		}
	},




}
